const initialSearchFields = {
  fullName: null,
  userName: null,
  roleId: null,
  phoneNumber: null,
  nationalCode: null,
  personnelNumber: null,
};
export default {
  data() {
    return {
      actionList: [
        {
          title: 'جزئیات اطلاعات',
          id: '1',
          type: 'moreInformation',
          icon: 'mdi-information mdi-18px',
        },
        {
          title: 'ویرایش سطح دسترسی',
          id: '2',
          type: 'permisions',
          icon: 'mdi-account-lock mdi-18px',
        },
        {
          title: 'ویرایش نقش ها',
          id: '3',
          type: 'roles',
          icon: 'mdi-account-cog mdi-18px',
        },
        {
          title: 'ویرایش شهرستان ها',
          id: '4',
          type: 'cities',
          icon: 'mdi-home-city mdi-18px',
        },
        {
          title: 'ویرایش بیمارستان ها',
          id: '5',
          type: 'hospitals',
          icon: 'mdi-hospital-building mdi-18px',
        },
        {
          title: 'ویرایش پایگاه',
          id: '12',
          type: 'stations',
          icon: 'mdi-home mdi-18px',
        },
        {
          title: 'ویرایش سازمان همکار',
          id: '11',
          type: 'otherOrganizations',
          icon: 'mdi-office-building mdi-18px',
        },
        {
          title: 'اطلاعات شخصی',
          id: '6',
          type: 'personalInfo',
          icon: 'mdi-badge-account mdi-18px',
        },
        {
          title: 'گروه کاربری',
          id: '7',
          type: 'groups',
          icon: 'mdi-account-group mdi-18px',
        },
        {
          title: 'آزاد کردن حساب کاربری',
          id: '8',
          type: 'releaze',
          icon: 'mdi-account-key mdi-18px',
        },
        {
          title: 'تعیین بازه زمانی دسترسی',
          id: '9',
          type: 'accessTime',
          icon: 'mdi-clipboard-text-clock mdi-18px',
        },
        {
          title: 'اتمام نشست جاری',
          id: '10',
          type: 'logOutUser',
          icon: 'mdi-logout mdi-18px',
        },
      ],
      confimType: '',
      disabelConfirm: false,
      //edit other orgnization
      otherOrganizationModal: false,
      allUserSelectedOtherOrganizations: [],
      allUserOtherOrganizations: [],
      //edit permission
      permissionModal: false,
      allUserSelectedPermissions: [],
      allUserPermissions: [],
      //edit role
      roleModal: false,
      allUserRoles: [],
      allUserSelectedRoles: [],
      //edit city
      cityModal: false,
      allUserCitys: [],
      allUserSelectedCitys: [],
      //edit hospital
      editHopitalSearchText: '',
      editSelectedHopitalSearchText: '',
      hospitalModal: false,
      allUserHospitals: [],
      allUserSelectedHospitals: [],
      //set password
      changeUserPasswordModal: false,
      setUserPassword: '',
      setUserPasswordRepeat: '',
      setUserPasswordClass: 'password',
      setUserPasswordIcon: 'mdi-eye-off',
      setUserRepeatPasswordClass: 'password',
      setUserRepeatPasswordIcon: 'mdi-eye-off',
      setUserPasswordChangePassNext: false,
      isEditingStationModaOpen: false,
      //search\
      searchFields: { ...initialSearchFields },
      searchTitle: '',
      searchModal: false,
      isSearch: false,
    };
  },
  methods: {
    setActionType: function (type, data, moreInfo) {
      if (type == 'moreInformation') {
        this.userId = data.id;
        this.goToDetailPage();
      } else if (type == 'permisions') {
        this.confimType = 'permision';
        this.userId = data.id;
        this.showEditPermissionModal();
      } else if (type == 'roles') {
        this.confimType = 'role';
        this.userId = data.id;
        this.showEditRoleModal();
      } else if (type == 'cities') {
        this.confimType = 'city';
        this.userId = data.id;
        this.showEditCityModal();
      } else if (type == 'hospitals') {
        this.confimType = 'hospital';
        this.userId = data.id;
        this.showEditHospitalModal();
      } else if (type == 'enableDisable') {
        this.userId = data.id;
        this.changeStatusFunction(moreInfo);
      } else if (type == 'setUserPassword') {
        this.confimType = 'setUserPassword';
        this.userId = data.id;
        this.showSetPasswordModal();
      } else if (type == 'edit') {
        this.userId = data.id;
        this.goToEditPage();
      } else if (type == 'personalInfo') {
        this.userId = data.id;
        this.goToPeronalInformationPage();
      } else if (type == 'otherOrganizations') {
        this.confimType = 'otherOrganization';
        this.userId = data.id;
        this.showEditOtherOrganizationModal();
      } else if (type === 'stations') {
        (this.confirmType = 'stations'), (this.userId = data?.id);
        this.showEditStationModal();
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'permision') {
        this.$refs.confirm.title = 'ویرایش سطح دسترسی';
        this.$refs.confirm.text = 'از ویرایش سطح دسترسی ها اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'role') {
        this.$refs.confirm.title = 'ویرایش نقش';
        this.$refs.confirm.text = 'از ویرایش نقش ها اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'city') {
        this.$refs.confirm.title = 'ویرایش شهرستان';
        this.$refs.confirm.text = 'از ویرایش شهرستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'hospital') {
        this.$refs.confirm.title = 'ویرایش بیمارستان';
        this.$refs.confirm.text = 'از ویرایش بیمارستان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'deactive') {
        this.$root.$refs.confirmDialog.text = 'از فعال کردن کاربر اطمینان دارید؟';
        this.$root.$refs.confirmDialog.showConfirmDialog = true;
      } else if (this.confimType == 'active') {
        this.$root.$refs.confirmDialog.text = 'از غیر فعال کردن کاربر اطمینان دارید؟';
        this.$root.$refs.confirmDialog.showConfirmDialog = true;
      } else if (this.confimType == 'setUserPassword') {
        this.$refs.confirm.title = 'تغییر رمز عبور';
        this.$root.$refs.confirmDialog.text = 'از تغییر رمز عبور کاربر اطمینان دارید؟';
        this.$root.$refs.confirmDialog.showConfirmDialog = true;
      } else if (this.confimType == 'otherOrganization') {
        this.$refs.confirm.title = 'ویرایش سازمان همکار';
        this.$root.$refs.confirmDialog.text = 'از ویرایش سازمان های همکار کاربر اطمینان دارید؟';
        this.$root.$refs.confirmDialog.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'permision') {
        this.disabelConfirm = true;
        this.EditUserPermissionFunction();
      } else if (this.confimType == 'role') {
        this.disabelConfirm = true;
        this.EditUserRoleFunction();
      } else if (this.confimType == 'city') {
        this.disabelConfirm = true;
        this.EditUserCityFunction();
      } else if (this.confimType == 'hospital') {
        this.disabelConfirm = true;
        this.EditUserHospitalFunction();
      } else if (this.confimType == 'deactive') {
        this.disabelConfirm = true;
        this.activeUserFunction();
      } else if (this.confimType == 'active') {
        this.disabelConfirm = true;
        this.deActiveUserFunction();
      } else if (this.confimType == 'setUserPassword') {
        this.disabelConfirm = true;
        this.setUserPasswordFunction();
      } else if (this.confimType == 'otherOrganization') {
        this.disabelConfirm = true;
        this.EditUserOtherOrganizationFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'permision') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'role') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'city') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'hospital') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'deactive') {
        this.$root.$refs.confirmDialog.showConfirmDialog = false;
        this.disabelConfirm = false;
        this.getListOfUsersWithPagination();
      } else if (this.confimType == 'active') {
        this.$root.$refs.confirmDialog.showConfirmDialog = false;
        this.disabelConfirm = false;
        this.getListOfUsersWithPagination();
      } else if (this.confimType == 'setUserPassword') {
        this.$root.$refs.confirmDialog.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'otherOrganization') {
        this.$root.$refs.confirmDialog.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //other organization part
    showEditOtherOrganizationModal: function () {
      this.allUserSelectedOtherOrganizations = [];
      this.allUserOtherOrganizations = [];
      this.getListOfOtherOrganizationsForOther();
    },
    readyUserOtherOrganization: function () {
      this.getUserOtherOrganizationList();
    },
    defineUserOtherOrganization: function () {
      if (this.allUserSelectedOtherOrganizations.length > 0) {
        for (let i = 0; i < this.allUserOtherOrganizations.length; i++) {
          for (let j = 0; j < this.allUserSelectedOtherOrganizations.length; j++) {
            if (
              this.allUserOtherOrganizations[i].id === this.allUserSelectedOtherOrganizations[j].id
            ) {
              this.allUserOtherOrganizations.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.otherOrganizationModal = true;
    },
    addOtherOrganizationToUserOtherOrganizations: function (otherOrganization) {
      this.allUserSelectedOtherOrganizations.push(otherOrganization);
      for (let i = 0; i < this.allUserOtherOrganizations.length; i++) {
        if (otherOrganization.id == this.allUserOtherOrganizations[i].id) {
          this.allUserOtherOrganizations.splice(i, 1);
          break;
        }
      }
    },
    removeOtherOrganizationFromUserOtherOrganizations: function (otherOrganization) {
      this.allUserOtherOrganizations.push(otherOrganization);
      for (let i = 0; i < this.allUserSelectedOtherOrganizations.length; i++) {
        if (otherOrganization.id == this.allUserSelectedOtherOrganizations[i].id) {
          this.allUserSelectedOtherOrganizations.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserOtherOrganization: function () {
      this.allUserSelectedOtherOrganizations = [];
      this.allUserOtherOrganizations = [];
      this.otherOrganizationModal = false;
    },
    // station part
    showEditStationModal: function () {
      this.isEditingStationModaOpen = true;
    },
    closeEditStationModal: function () {
      this.isEditingStationModaOpen = false;
    },
    // end station part
    //permission part
    showEditPermissionModal: function () {
      this.allUserSelectedPermissions = [];
      this.allUserPermissions = [];
      this.getAllPermissions();
    },
    readyUserPermission: function () {
      this.getUserPermissionList();
    },
    defineUserPermissions: function () {
      if (this.allUserSelectedPermissions.length > 0) {
        for (let i = 0; i < this.allUserPermissions.length; i++) {
          for (let j = 0; j < this.allUserSelectedPermissions.length; j++) {
            if (this.allUserPermissions[i].id === this.allUserSelectedPermissions[j].id) {
              this.allUserPermissions.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.permissionModal = true;
    },
    addPermssionToUserPermissions: function (permission) {
      this.allUserSelectedPermissions.push(permission);
      for (let i = 0; i < this.allUserPermissions.length; i++) {
        if (permission.id == this.allUserPermissions[i].id) {
          this.allUserPermissions.splice(i, 1);
          break;
        }
      }
    },
    removePermissionFromUserPermissions: function (permission) {
      this.allUserPermissions.push(permission);
      for (let i = 0; i < this.allUserSelectedPermissions.length; i++) {
        if (permission.id == this.allUserSelectedPermissions[i].id) {
          this.allUserSelectedPermissions.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserPermision: function () {
      this.allUserSelectedPermissions = [];
      this.allUserPermissions = [];
      this.permissionModal = false;
    },
    //role part
    showEditRoleModal: function () {
      this.allUserSelectedRoles = [];
      this.allUserRoles = [];
      this.getAllRoles();
    },
    readyUserRole: function () {
      this.getUserRoleList();
    },
    defineUserRoles: function () {
      if (this.allUserSelectedRoles.length > 0) {
        for (let i = 0; i < this.allUserRoles.length; i++) {
          for (let j = 0; j < this.allUserSelectedRoles.length; j++) {
            if (this.allUserRoles[i].id === this.allUserSelectedRoles[j].id) {
              this.allUserRoles.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.roleModal = true;
    },
    addRoleToUserRoles: function (role) {
      this.allUserSelectedRoles.push(role);
      for (let i = 0; i < this.allUserRoles.length; i++) {
        if (role.id == this.allUserRoles[i].id) {
          this.allUserRoles.splice(i, 1);
          break;
        }
      }
    },
    removeRoleFromUserRoles: function (role) {
      this.allUserRoles.push(role);
      for (let i = 0; i < this.allUserSelectedRoles.length; i++) {
        if (role.id == this.allUserSelectedRoles[i].id) {
          this.allUserSelectedRoles.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserRole: function () {
      this.allUserSelectedRoles = [];
      this.allUserRoles = [];
      this.roleModal = false;
    },
    //city part
    showEditCityModal: function () {
      this.allUserSelectedCitys = [];
      this.allUserCitys = [];
      this.getListOfCitysForOther();
    },
    readyUserCity: function () {
      this.getUserCityList();
    },
    defineUserCitys: function () {
      if (this.allUserSelectedCitys.length > 0) {
        for (let i = 0; i < this.allUserCitys.length; i++) {
          for (let j = 0; j < this.allUserSelectedCitys.length; j++) {
            if (this.allUserCitys[i].id === this.allUserSelectedCitys[j].id) {
              this.allUserCitys.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.cityModal = true;
    },
    addCityToUserCitys: function (city) {
      this.allUserSelectedCitys.push(city);
      for (let i = 0; i < this.allUserCitys.length; i++) {
        if (city.id == this.allUserCitys[i].id) {
          this.allUserCitys.splice(i, 1);
          break;
        }
      }
    },
    removeCityFromUserCitys: function (city) {
      this.allUserCitys.push(city);
      for (let i = 0; i < this.allUserSelectedCitys.length; i++) {
        if (city.id == this.allUserSelectedCitys[i].id) {
          this.allUserSelectedCitys.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserCity: function () {
      this.allUserSelectedCitys = [];
      this.allUserCitys = [];
      this.cityModal = false;
    },
    //hospital part
    showEditHospitalModal: function () {
      this.allUserSelectedHospitals = [];
      this.allUserHospitals = [];
      this.getListOfHospitalsForOther();
    },
    readyUserHospital: function () {
      this.getUserHospitalList();
    },
    defineUserHospitals: function () {
      if (this.allUserSelectedHospitals.length > 0) {
        for (let i = 0; i < this.allUserHospitals.length; i++) {
          for (let j = 0; j < this.allUserSelectedHospitals.length; j++) {
            if (this.allUserHospitals[i].id === this.allUserSelectedHospitals[j].id) {
              this.allUserHospitals.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
      this.hospitalModal = true;
    },
    addHospitalToUserHospitals: function (hospital) {
      this.allUserSelectedHospitals.push(hospital);
      for (let i = 0; i < this.allUserHospitals.length; i++) {
        if (hospital.id == this.allUserHospitals[i].id) {
          this.allUserHospitals.splice(i, 1);
          break;
        }
      }
    },
    removeHospitalFromUserHospitals: function (hospital) {
      this.allUserHospitals.push(hospital);
      for (let i = 0; i < this.allUserSelectedHospitals.length; i++) {
        if (hospital.id == this.allUserSelectedHospitals[i].id) {
          this.allUserSelectedHospitals.splice(i, 1);
          break;
        }
      }
    },
    cancleEditUserHospital: function () {
      this.allUserSelectedHospitals = [];
      this.allUserHospitals = [];
      this.hospitalModal = false;
    },
    addAllHospitals: function () {
      for (let i = 0; i < this.allUserHospitals.length; i++) {
        this.allUserSelectedHospitals.push(this.allUserHospitals[i]);
        this.allUserHospitals.splice(i, 1);
        i--;
      }
    },
    removeAllHospitals: function () {
      for (let i = 0; i < this.allUserSelectedHospitals.length; i++) {
        this.allUserHospitals.push(this.allUserSelectedHospitals[i]);
        this.allUserSelectedHospitals.splice(i, 1);
        i--;
      }
    },
    //enable disable
    changeStatusFunction: function (isEnable) {
      if (isEnable) {
        //غیر فعال شود
        this.confimType = 'deactive';
        this.showConfirmDialogFunction();
      } else {
        //فعال شود
        this.confimType = 'active';
        this.showConfirmDialogFunction();
      }
    },
    //set password
    showSetPasswordModal: function () {
      this.changeUserPasswordModal = true;
    },
    cancelSetUserPasword: function () {
      this.setUserPassword = '';
      this.setUserPasswordRepeat = '';
      this.setUserPasswordChangePassNext = false;
      this.changeUserPasswordModal = false;
    },
    setPasswordEyeClick: function (type) {
      if (type == 'password') {
        if (this.setUserPasswordIcon == 'mdi-eye-off') {
          this.setUserPasswordIcon = 'mdi-eye';
          this.setUserPasswordClass = 'text';
        } else {
          this.setUserPasswordIcon = 'mdi-eye-off';
          this.setUserPasswordClass = 'password';
        }
      } else if (type == 'repeatPassword') {
        if (this.setUserRepeatPasswordIcon == 'mdi-eye-off') {
          this.setUserRepeatPasswordIcon = 'mdi-eye';
          this.setUserRepeatPasswordClass = 'text';
        } else {
          this.setUserRepeatPasswordIcon = 'mdi-eye-off';
          this.setUserRepeatPasswordClass = 'password';
        }
      }
    },
    //detail
    goToDetailPage: function () {
      this.$router.push({ name: 'detailUser', params: { id: this.userId } });
    },
    //edit User
    goToEditPage: function () {
      this.$router.push({ name: 'editUser', params: { id: this.userId } });
    },
    //Add Page
    goToAddPage: function () {
      this.$router.push({ name: 'addUser' });
    },
    //PeronalInformation Page
    goToPeronalInformationPage: function () {
      this.$router.push({
        name: 'userPersonalInformation',
        params: { id: this.userId },
      });
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
      if (!this.allRoles.length) {
        this.getAllRoles();
      }
    },
    initialFilter: function () {
      const filterQuery = this.$route.query;
      delete filterQuery?.pageSize;
      delete filterQuery?.page;
      this.searchFields.fullName = filterQuery?.fullName ?? '';
      this.searchFields.userName = filterQuery?.userName ?? '';
      this.searchFields.personnelNumber = filterQuery?.personnelNumber ?? '';
      this.searchFields.roleId = filterQuery?.roleId?.map((id) => +id);
      this.searchFields.phoneNumber = filterQuery?.phoneNumber ?? '';
      this.searchFields.nationalCode = filterQuery?.nationalCode ?? '';
    },
    removeFalsyProperty: function (obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === '' || obj[key] === undefined) delete obj[key];
      });
      return obj;
    },
    setFilter: function () {
      const preQuery = this.$route.query;

      // const searchTemp = { ...this.searchFields };
      // delete searchTemp.roleId;
      this.$router.replace({
        query: {
          ...preQuery,
          page: 1,
          ...this.searchFields,
        },
      });
    },
    removeQuery: function () {
      const preQuery = { ...this.$route.query };
      Object.keys(this.searchFields).forEach((key) => {
        delete preQuery?.[key];
      });
      this.$router.replace({
        query: {
          ...preQuery,
          page: 1,
        },
      });
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.setFilter();
      this.getListOfUsersWithPagination();
    },
    removeFilters: function () {
      this.cancelSearch();
      this.isSearch = false;
      // this.page = 1;
      this.removeQuery();
      // this.$refs.pagination.page = 1;
      this.getListOfUsersWithPagination();
    },
    cancelSearch: function () {
      this.searchFields = { ...initialSearchFields };
      this.searchModal = false;
      this.search();
    },
  },
  computed: {
    allUserFilterdHospitals() {
      return this.allUserHospitals.filter((u) => {
        return u.title.includes(this.editHopitalSearchText);
      });
    },
    allUserSelectedFilterdHospitals() {
      return this.allUserSelectedHospitals.filter((u) => {
        return u.title.includes(this.editSelectedHopitalSearchText);
      });
    },
  },
  watch: {
    searchFields: {
      handler(currentVal) {
        this.isSearch = Object.values(currentVal)?.some((val) => {
          return val;
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
